import {createApp} from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/styles.css';
import './assets/js/script.js';
import PrimeVue from 'primevue/config';
import router from './router/routes.js';
import {ToastContainer} from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import VueFormWizard from 'vue3-form-wizard';
import 'vue3-form-wizard/dist/style.css';
import VueApexCharts from 'vue3-apexcharts';
import i18n from "@/services/i18n";
import store from './store';
import Vuelidate from '@vuelidate/core'
// import BootstrapVue3 from 'bootstrap-vue-3';
// import IconsPlugin from 'bootstrap-vue-3';
import {BFormFile, BFormGroup, BootstrapVue3, IconsPlugin} from 'bootstrap-vue-3';

import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {
    faAngleDown,
    faChevronRight,
    faCommentDots,
    faEye,
    faEyeSlash,
    faGlobe,
    faPenToSquare,
    fas
} from '@fortawesome/free-solid-svg-icons';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import {Carousel, Slide} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import VueDraggable from "vuedraggable";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
// vue js 3 Datatable


library.add(faChevronRight, faCommentDots, faAngleDown, faPenToSquare, faEye, faEyeSlash, faGlobe,fas);

const app = createApp(App);

app.component('ToastContainer', ToastContainer);
app.use(VueFormWizard);
app.component('VueDatePicker', VueDatePicker);
app.component('CarOusel', Carousel);
app.component('SlIde', Slide);
app.use(router);
app.use(PrimeVue);
app.use(store);
app.use(BootstrapVue3);
app.use(VueDraggable);
app.use(IconsPlugin);
app.use(i18n);
app.use(VueApexCharts);
app.component('apexChart', VueApexCharts);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('BFormFile', BFormFile);
app.component('BFormGroup', BFormGroup);
app.component('QuillEditor', QuillEditor);
app.use(Vuelidate)

app.mount('#app');
